import React, { FC } from 'react';

import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import { ETypography } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

import { EDataTestId } from '@aqx-core/common/data-test-id/types';
import { useCompanyProfile } from '@aqx-core/common/services/company';
import { openUrl } from '@aqx-member/web/utils/url/open-url';

interface IAuthAcknowledgementTextProps {
  prefixText: string;
  postfixText?: string;
}

const AuthAcknowledgementText: FC<IAuthAcknowledgementTextProps> = ({ prefixText, postfixText }) => {
  const { t } = useTranslation();

  const companyProfile = useCompanyProfile();
  const { webtraderMemberTncUrl, webtraderMemberPolicyUrl, webtraderMemberRiskDisclosureUrl } = companyProfile || {};

  const onClickActionText = (url?: string) => {
    openUrl(url, '_blank');
  };

  return (
    <StyledContainer typography={ETypography.TEXT_M_REGULAR}>
      {prefixText}{' '}
      <StyledActionTextContainer data-testid={EDataTestId.TNC} onClick={() => onClickActionText(webtraderMemberTncUrl)}>
        <StyledActionText typography={ETypography.TEXT_M_REGULAR}>{t('Terms and Conditions')}</StyledActionText>
      </StyledActionTextContainer>
      ,{' '}
      <StyledActionTextContainer
        onClick={() => onClickActionText(webtraderMemberPolicyUrl)}
        data-testid={EDataTestId.PRIVACY_POLICY}
      >
        <StyledActionText typography={ETypography.TEXT_M_REGULAR}>{t('Privacy Policy')}</StyledActionText>
      </StyledActionTextContainer>{' '}
      {t('and')}{' '}
      <StyledActionTextContainer
        onClick={() => onClickActionText(webtraderMemberRiskDisclosureUrl)}
        data-testid={EDataTestId.RISK_DISCLOSURE}
      >
        <StyledActionText typography={ETypography.TEXT_M_REGULAR}>{t('Risk Disclosure Document')}</StyledActionText>
      </StyledActionTextContainer>
      {postfixText ? ` ${postfixText}` : '.'}
    </StyledContainer>
  );
};

export default AuthAcknowledgementText;

const StyledContainer = styled(UIText)`
  display: flex;
  display: inline;
`;

const StyledActionTextContainer = styled.div`
  display: inline;
  cursor: pointer;
`;

const StyledActionText = styled(UIText)`
  display: inline;

  color: ${({ theme }) => theme.themeColors.primary};
`;
